import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { motion } from 'framer-motion';
import './TechnologyServices.css';
import frontendImg from '../../../assets/Images/frontend.jpg';
import backendImg from '../../../assets/Images/backend.png';
import ios from '../../../assets/Images/ios.png';
import android from '../../../assets/Images/android.png';
import thirdparty from '../../../assets/Images/thirdpartyservices.png'
import cloudImg from '../../../assets/Images/cloudapp.png';

const services = [
  {
    id: 1,
    title: 'Frontend',
    desc: 'Modern web interfaces with React, Vue, and Angular',
    image: frontendImg,
    link: '/technologies/stack#frontend'
  },
  {
    id: 2,
    title: 'Backend',
    desc: 'Scalable server solutions with Node.js and Python',
    image: backendImg,
    link: '/technologies/stack#backend'
  },
  {
    id: 3,
    title: 'iOS Development',
    desc: 'Native iOS apps with Swift and SwiftUI',
    image: ios,
    link: '/technologies/stack#ios'
  },
  {
    id: 4,
    title: 'Android Development',
    desc: 'Native Android apps with Kotlin and Java',
    image: android,
    link: '/technologies/stack#android'
  },
  {
    id: 5,
    title: 'Third Party Services',
    desc: 'Integration with popular APIs and platforms',
    image: thirdparty,
    link: '/technologies/stack#third-party'
  },
  {
    id: 6,
    title: 'Cloud Solutions',
    desc: 'AWS, Google Cloud, and Azure services',
    image: cloudImg,
    link: '/technologies/stack#cloud'
  },
  // {
  //   id: 7,
  //   title: 'AI & Automation',
  //   desc: 'Machine learning and process automation',
  //   image: aiImg,
  //   link: '/technologies/stack#ai'
  // },
  // {
  //   id: 8,
  //   title: 'UI/UX Design',
  //   desc: 'User-centered design and prototyping',
  //   image: uiuxImg,
  //   link: '/technologies/stack#design'
  // }
];

const TechnologyServices = () => {
  return (
    <Box className="technology-services">
      {/* Background Text Elements */}
      {/* <Typography className="background-text">Innovation</Typography>
      <Typography className="background-text">Technology</Typography>
      <Typography className="background-text">Solutions</Typography> */}

      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="technology-services-header"
        >
          <Typography
            variant="h2"
            className="technology-services-title"
          >
            Comprehensive Solutions & Expertise
          </Typography>
          <Typography
            className="technology-services-subtitle"
          >
            Our technology services adapt to your needs - whether you're looking for complete end-to-end teams or specialized experts to enhance your existing projects. We seamlessly integrate our technical prowess with your vision.
          </Typography>
        </motion.div>

        <div className="services-scroll-container">
          <div className="services-row">
            {services.map((service, index) => (
              <motion.div
                key={service.id}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="service-card-wrapper"
              >
                <Box
                  className="tech-service-card"
                  component="a"
                  href={service.link}
                >
                  <Box
                    className="service-image"
                    style={{
                      backgroundImage: `url(${service.image})`
                    }}
                  >
                    <Box className="technology-service-overlay">
                      <Typography variant="h3" className="technology-service-title">
                        {service.title}
                      </Typography>
                      <Typography className="technology-service-desc">
                        {service.desc}
                      </Typography>
                      {/* <Typography className="technology-service-view">
                        View Details
                      </Typography> */}
                    </Box>
                  </Box>
                </Box>
              </motion.div>
            ))}
          </div>
        </div>
      </Container>
    </Box>
  );
};

export default TechnologyServices; 